import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count", "checkbox"]

  connect() {
    this.updateCount()
    // Add click outside listener
    document.addEventListener('click', this.handleClickOutside.bind(this))
    
    // Prevent dropdown from closing when clicking inside
    this.element.addEventListener('click', this.handleInsideClick.bind(this))
  }

  disconnect() {
    // Remove click outside listener
    document.removeEventListener('click', this.handleClickOutside.bind(this))
    this.element.removeEventListener('click', this.handleInsideClick.bind(this))
  }

  toggle(event) {
    // Prevent the dropdown from closing when clicking the button
    event.stopPropagation()
  }

  updateCount() {
    const checkedBoxes = this.element.querySelectorAll('input.company-checkbox[type="checkbox"]:checked')
    const countElement = this.element.querySelector('.selected-count')
    
    if (checkedBoxes.length === 0) {
      countElement.textContent = 'All Companies'
    } else if (checkedBoxes.length === 1) {
      countElement.textContent = '1 Company'
    } else {
      countElement.textContent = `${checkedBoxes.length} Companies`
    }
  }

  selectAll(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const checkboxes = this.element.querySelectorAll('input.company-checkbox[type="checkbox"]')
    
    checkboxes.forEach(checkbox => {
      checkbox.checked = true
    })
    
    this.updateCount()
  }

  clearAll(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const checkboxes = this.element.querySelectorAll('input.company-checkbox[type="checkbox"]')
    
    checkboxes.forEach(checkbox => {
      checkbox.checked = false
    })
    
    this.updateCount()
  }

  // Handle individual checkbox changes
  handleCheckboxChange(event) {
    this.updateCount()
  }

  handleInsideClick(event) {
    // Prevent dropdown from closing when clicking on checkboxes, labels, or dropdown items
    if (event.target.closest('.dropdown-item') || 
        event.target.type === 'checkbox' || 
        event.target.closest('label')) {
      event.stopPropagation()
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      const dropdown = this.element.querySelector('.dropdown-menu')
      if (dropdown.classList.contains('show')) {
        // Bootstrap 5 way to close dropdown
        const dropdownInstance = bootstrap.Dropdown.getInstance(this.element.querySelector('.dropdown-toggle'))
        if (dropdownInstance) {
          dropdownInstance.hide()
        }
      }
    }
  }
} 